import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { Box } from '@components/Box';
import {
  FormButtonsContainer,
  FormSectionContainer,
} from '@components/Container';
import { CancelLinkButton } from '@components/Form';
import { FormikInput } from '@components/Form/FormikInput';
import { Loading } from '@components/Loading';
import { routes } from '@config/routes';
import { CurrencyViewModel, currencyDefaultValue } from '@models/Currency';
import { CurrencyService } from '@services/Currency';

export const CurrencyDetails: React.FC = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [currency, setcurrency] = useState(currencyDefaultValue);
  const navigate = useNavigate();

  const loadData = () => {
    CurrencyService.getById(Number(id))
      .then((response) => response.json() as Promise<CurrencyViewModel>)
      .then((result) => {
        if (result.id) {
          setcurrency(result);
          setIsLoading(false);
          console.log('Success: Fetch the record.');
        } else {
          console.log('Error: Failed to get record.');
        }
      })
      .catch((error) => {
        alert('Error: Failed to handle thr request');
        console.log(error);
      });
  };

  useEffect(() => {
    loadData();
  }, [id]);

  const handleNameClick = (currencyId: number) => {
    navigate(`${routes.CURRENCY}/${currencyId}/details`);
  };

  if (isLoading) {
    return <Loading />;
  } else {
    return (
      <>
        <Box size="medium">
          <Formik
            initialValues={currency}
            validateOnBlur={true}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSubmit={() => {}}
          >
            {() => {
              return (
                <>
                  <form>
                    <FormSectionContainer>
                      <FormikInput
                        label="Firstname"
                        name="firstname"
                        onClick={() => handleNameClick(currency.id)}
                      />
                      <FormikInput label="Name" name="name" />
                      <FormikInput label="Short Name" name="shortName" />
                      <FormikInput label="Symbol" name="symbol" />
                    </FormSectionContainer>
                    <FormButtonsContainer>
                      <CancelLinkButton to={`${routes.CURRENCY}`} />
                      <button
                        className="bg-[#58993C] w-20 ml-4 rounded-md "
                        onClick={() =>
                          navigate(`${routes.CONTACTS}/${currency.id}/edit`)
                        }
                      >
                        Edit
                      </button>
                    </FormButtonsContainer>
                  </form>
                </>
              );
            }}
          </Formik>
        </Box>
      </>
    );
  }
};
